import { USER_SESSION } from '../../constants';

export const SessionHandlerScript = () => {
    return (
        <script
            dangerouslySetInnerHTML={{
                __html: /* javascript */ `
                      const LOCK = 'om:session';
                      let release = () => {};
                      const clearSessionCookie = () => {
                          document.cookie = '${USER_SESSION}=; Max-Age=0; path=/';
                      };
                      const startSessionTracking = async () => {
                          const state = await navigator.locks.query();
                          const hasOtherTab = state.held?.some((l) => l.name === LOCK && l.mode === 'shared');
                          const hasSessionCookie = document.cookie.split('; ').some((cookie) => cookie.startsWith('${USER_SESSION}='));
                          if (!hasOtherTab && hasSessionCookie && !sessionStorage.getItem('${USER_SESSION}')) {
                              clearSessionCookie();
                              document.body.style.display = 'none';
                              window.location.reload();
                          }
                          if (hasOtherTab) {
                              sessionStorage.setItem('${USER_SESSION}', new Date().toISOString());
                          }
                          navigator.locks.request(
                              LOCK,
                              { mode: 'shared' },
                              () =>
                                  new Promise((resolve) => {
                                      release = resolve;
                                  }),
                          );
                      };
                      window.addEventListener('pagehide', () => {
                          release();
                          setTimeout(async () => {
                              await navigator.locks.request(
                                  LOCK,
                                  {
                                      mode: 'exclusive',
                                      ifAvailable: true,
                                  },
                                  async (lock) => {
                                      if (!lock) {
                                          return;
                                      }
                                      clearSessionCookie();
                                  },
                              );
                          }, 0);
                      });
                      startSessionTracking();
                      `,
            }}
        />
    );
};
